import { InjectionToken } from '@angular/core';

export interface AppInsightsConfig {
	connectionString: string;
	enabled: boolean;
	/** `environment.id` — tagged onto every envelope as `ai.application.ver` / `data.environmentId`. */
	environmentId: string;
	/** `ai.cloud.role` — distinguishes the two apps' telemetry in Application Insights. */
	cloudRole: string;
}

/** Each AppModule provides this from its own `environment.applicationInsights` + `environment.id`. */
export const APP_INSIGHTS_CONFIG = new InjectionToken<AppInsightsConfig>('APP_INSIGHTS_CONFIG');
